import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Navigate, useNavigate } from "react-router";
import { api } from "../api/client";
import { qk } from "../api/queries";
import { ProjectForm } from "../components/ProjectForm";
import { useCurrentUser } from "../lib/auth";

export function NewProjectPage() {
  const me = useCurrentUser();
  const qc = useQueryClient();
  const navigate = useNavigate();
  const create = useMutation({
    meta: { inlineError: true },
    mutationFn: api.createProject,
    onSuccess: (p) => {
      qc.invalidateQueries({ queryKey: qk.projects });
      navigate(`/p/${p.id}/settings/general?created=1`);
    },
  });
  if (me.role !== "admin") return <Navigate to="/" replace />;
  return (
    <div className="page page-narrow">
      <h1 className="page-title">New project</h1>
      <p className="muted">
        The project starts with the default workflow (Task Definition → Detailed Design → Implementation &amp;
        Verification → Integration → Done). Add an environment template and secrets next.
      </p>
      <ProjectForm submitLabel="Create project" onSubmit={(p) => create.mutate(p)} pending={create.isPending} error={create.error} />
    </div>
  );
}
